// CSS Modules - component class name prefix: ProductDownloadsSection__

<template>
  <div :class="$style.container" v-if="dataLoaded">
    <div :class="$style.select">
      <FormSelect
        :key="`force${dataLoaded}`"
        :hasFilter="false"
        v-model="filter.initialSelectOption"
        :colour="filter.colour"
        :options="this.selectOptions"
        :initialOption="filter.initialSelectOption"
        @input="updateFilter"
      />
    </div>
    <section
      v-for="(category, categoryIndex) of downloads"
      :key="`category${categoryIndex}`"
      :set="(currentCategory = category.viewType)"
      :class="[
        $style.section,
        {
          'columns is-mobile is-multiline':
            category.viewType === '3d_data' || category.viewType === 'software'
        },
        category.label === selectedFilterOption || !selectedFilterOption
          ? $style.active
          : $style.inactive
      ]"
    >
      <h3
        v-if="currentCategory === '3d_data' || currentCategory === 'software'"
      >
        {{ category.label }}
      </h3>
      <h2 v-else>{{ category.label }}</h2>
      <template
        v-if="
          currentCategory !== '3d_data' &&
            currentCategory !== 'software' &&
            currentCategory !== 'declarations'
        "
      >
        <section
          v-for="(section, sectionIndex) in getFilesSortByCategory(
            category.files,
            currentCategory
          )"
          :key="`category${categoryIndex}section${sectionIndex}`"
        >
          <div v-if="currentCategory !== 'approvals'" class="columns">
            <div class="column is-half">
              <p v-html="section.title"></p>
            </div>
            <div class="column is-half">
              <CountryDownloadBox
                v-if="
                  section.urls.length &&
                    downloadItemHasFlagOrLanguage(section.urls)
                "
                :key="
                  `category${categoryIndex}section${sectionIndex}countryDownloadBox`
                "
                :countries="section.urls"
                :labels="config.labels"
                :section="category.label"
                :title="section.title || section.subHeading"
                :types="config.productTypes"
              />
            </div>
          </div>
          <div v-if="currentCategory === 'approvals'" class="columns">
            <div class="column is-two-thirds">
              <div class="columns is-mobile">
                <div class="column is-2">
                  <img
                    v-if="section.logo"
                    :class="$style.image"
                    :src="section.logo"
                  />
                </div>
                <div class="column">
                  <dl class="columns is-multiline is-mobile is-gapless">
                    <dt class="column is-5">
                      {{ config.labels.certificationBody }}:
                    </dt>
                    <dd class="column is-7">
                      <strong v-html="section.title"></strong> ({{
                        section.certificateId
                      }})
                    </dd>
                    <dt class="column is-5">
                      {{ config.labels.typeOfApproval }}:
                    </dt>
                    <dd class="column is-7">
                      <span
                        v-for="(keyword, kIndex) in section.keywords"
                        v-text="keyword.keyword"
                        :key="
                          `category${categoryIndex}section${sectionIndex}keyword${kIndex}`
                        "
                        :class="$style.break"
                      ></span>
                    </dd>
                    <dt class="column is-5">
                      {{ config.labels.economicArea }}:
                    </dt>
                    <dd class="column is-7">
                      <span
                        v-for="(economicArea, eIndex) in section.economicArea"
                        v-text="economicArea"
                        :key="
                          `category${categoryIndex}section${sectionIndex}economicArea${eIndex}`
                        "
                        :class="$style.break"
                      ></span>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <div class="column is-one-third">
              <CountryDownloadBox
                v-if="
                  section.urls.length &&
                    downloadItemHasFlagOrLanguage(section.urls)
                "
                :key="
                  `category${categoryIndex}section${sectionIndex}countryDownloadBox`
                "
                :countries="section.urls"
                :labels="config.labels"
                :section="category.label"
                :title="`${section.title} (${section.certificateId})`"
                :subTitle="getApprovalSubTitle(section)"
                :types="config.productTypes"
              />
            </div>
          </div>
        </section>
      </template>
      <template v-if="currentCategory === 'declarations'">
        <section
          v-for="(section, sectionIndex) in category.files"
          :key="`category${categoryIndex}section${sectionIndex}`"
        >
          <div class="columns">
            <div class="column is-half">
              <p v-html="section.title"></p>
            </div>
            <div class="column is-half">
              <CountryDownloadBox
                v-if="
                  section.urls.length &&
                    downloadItemHasFlagOrLanguage(section.urls)
                "
                :key="
                  `category${categoryIndex}section${sectionIndex}countryDownloadBox`
                "
                :countries="section.urls"
                :labels="config.labels"
                :section="category.label"
                :title="section.title || section.subHeading"
                :types="config.productTypes"
              />
            </div>
          </div>
        </section>
      </template>
      <template v-if="currentCategory === '3d_data'">
        <section
          v-for="(section, sectionIndex) in category.files"
          :key="`category${categoryIndex}section${sectionIndex}`"
          class="column is-half"
        >
          <p v-html="section.title"></p>
          <DownloadButton
            v-if="section.metadata && section.urls[0]"
            :config="{
              metadata: section.metadata,
              title: section.title,
              wishlistTitle: section.title,
              types: config.productTypes,
              urls: section.urls[0]
            }"
            :section="currentCategory"
            :id="id"
            :labels="config.labels"
          />
        </section>
      </template>
      <template v-if="currentCategory === 'software'">
        <section
          v-for="(section, sectionIndex) in category.files"
          :key="`category${categoryIndex}section${sectionIndex}`"
          class="column is-half"
        >
          <p v-html="section.title"></p>
          <DownloadButton
            v-if="section.metadata[0] && section.urls[0]"
            :config="{
              metadata: section.metadata[0],
              title: section.title,
              wishlistTitle: section.title,
              types: config.productTypes,
              urls: section.urls[0]
            }"
            :section="currentCategory"
            :id="id"
            :labels="config.labels"
          />
          <DownloadButton
            v-if="section.urls[1] && section.metadata[1]"
            colour="white"
            :config="{
              metadata: section.metadata[1],
              title: section.title,
              wishlistTitle: section.title,
              types: config.productTypes,
              urls: section.urls[1]
            }"
            :section="currentCategory"
            :id="id"
            :labels="config.labels"
          />
        </section>
      </template>
    </section>
  </div>
</template>

<script>
import CountryDownloadBox from "../CountryDownloadBox/CountryDownloadBox";
import DownloadButton from "../DownloadButton/DownloadButton";
import FormSelect from "../FormSelect/FormSelect";
import axios from "axios";
import { externalDocumentPrefixes } from "../../shared/globals";
import { getValueByParameterCaseInsensitive } from "../../utils/helper";

export default {
  name: "ProductDownloadsSection",
  components: {
    CountryDownloadBox,
    DownloadButton,
    FormSelect
  },
  props: {
    downloads: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      default: () => {}
    },
    initialSelectOption: {
      type: String,
      default: ""
    },
    selectAllOption: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      filter: {
        colour: "blue",
        initialSelectOption: this.initialSelectOption
      },
      selectOptions: [this.selectAllOption],
      selectedFilterOption: null,
      externalCategories: ["approvals", "projectdocuments", "declarations"],
      dataLoaded: false,
      files: 0,
      currentLanguage: ""
    };
  },
  computed: {
    id: function() {
      return Math.random()
        .toString(36)
        .substr(2, 9);
    }
  },
  watch: {
    files: function(value, history) {
      if (history === 0 && value > 0) {
        for (let section of this.downloads) {
          this.selectOptions.push(section.label);
        }
        this.updateExternalItems();
      }
    }
  },
  updated() {
    this.files = this.downloads.length;
  },
  mounted() {
    this.files = this.downloads.length;
    this.currentLanguage = window.currentLanguage.toLowerCase();
  },
  methods: {
    getFilesSortByCategory(files, currentCategory) {
      return currentCategory === "approvals"
        ? [...files].sort((a, b) => (a.title > b.title ? -1 : 1))
        : files;
    },
    getApprovalSubTitle(section) {
      return section.keywords.length > 0
        ? section.keywords.map(keyword => keyword.keyword).join(", ")
        : undefined;
    },
    updateFilter(value) {
      this.selectedFilterOption = this.selectAllOption === value ? null : value;
    },
    downloadItemHasFlagOrLanguage(urls) {
      const urlItemsWithFlag = urls.filter(
        urlItem => urlItem.flag || urlItem.language
      );
      return urlItemsWithFlag.length > 0;
    },
    updateExternalItems() {
      const externalDownloads = this.downloads.filter(x =>
        this.externalCategories.includes(x.viewType)
      );
      if (externalDownloads.length > 0) {
        // Get mapping-data for external data
        const currentData = this;

        axios
          .get(currentData.config.mappingUrl)
          .then(response => {
            const mappings = response.data;

            externalDownloads.forEach(x => {
              const category = x.viewType;
              const urlPrefix = window.externalDocumentPrefixes
                ? window.externalDocumentPrefixes[category] || ""
                : externalDocumentPrefixes[category] || "";

              x.label = currentData.config.labels[category] || category;
              const optionIndex = this.selectOptions.indexOf(category);
              this.selectOptions[optionIndex] = x.label;

              for (const item of x.files) {
                // Get the logo for the approval
                let certLogos;
                const langItem = item.urls.find(
                  langItem =>
                    langItem.language === window.currentLanguage.toLowerCase()
                );
                item.title =
                  langItem && langItem.title ? langItem.title : item.title;

                if (category === "approvals") {
                  certLogos = mappings.logos.filter(
                    x => x.certificate == item.certificateBodyId
                  );

                  // Use mapped-values for the keywords
                  item.keywords = item.keywords.map(x => ({
                    id: x.id,
                    keyword: mappings.keywords[x.id] || x.keyword
                  }));
                }

                if (
                  category === "approvals" ||
                  category === "declarations" ||
                  category === "projectdocuments"
                ) {
                  // Use mapped values for economicAreas
                  item.economicArea = item.economicArea
                    ? item.economicArea.map(
                        x =>
                          getValueByParameterCaseInsensitive(
                            mappings.economicAreas,
                            x
                          ) ||
                          getValueByParameterCaseInsensitive(
                            mappings.countries,
                            x
                          ) ||
                          x
                      )
                    : null;

                  // Use mapped values for the languages
                  item.urls.forEach(x => {
                    x.flag =
                      getValueByParameterCaseInsensitive(
                        mappings.languages,
                        x.language
                      ) || "";
                    x.url = `${urlPrefix}${x.url}`;

                    if (x.language.length > 2) {
                      x.language =
                        mappings.languageCodes[x.language.toLowerCase()] ||
                        x.language;
                    }

                    if (category === "approvals") {
                      const logo =
                        certLogos.find(mapping => {
                          return item.keywords.map(keyword => {
                            return (
                              mapping.keyword == keyword.id &&
                              mapping.type === x.type
                            );
                          });
                        }) || "";

                      item.logo = item.logo || logo.url;
                    }
                  });
                }
              }
            });
            this.dataLoaded = true;
          })
          // eslint-disable-next-line no-console
          .catch(error => console.log(error));
      } else {
        return new Promise(() => {
          this.dataLoaded = true;
          return true;
        });
      }
    }
  }
};
</script>

<style module lang="scss">
@import "./ProductDownloadsSection.scss";
</style>
